import React from "react";
import Modal from "../common/Modal";
import { Link } from "react-router-dom";
import privacyImage from "../../images/Privacy Policy.webp";
import styles from "./PrivacyPolicyModal.module.scss";

const privacyCards = [
  {
    number: "1",
    icon: "👤",
    title: "Who This Privacy Policy Applies To",
    content:
      "This Privacy Policy applies to salon owners, managers, operators, staff members, and authorised representatives using Munafa Engine.",
  },
  {
    number: "2",
    icon: "📋",
    title: "What Kind of Information We May Collect",
    content:
      "We may collect personal information, business information, communication data, account details, and analytics information.",
  },
  {
    number: "3",
    icon: "📥",
    title: "How We Collect Information",
    content:
      "Information may be collected through forms, onboarding, communication channels, dashboards, and platform usage.",
  },
  {
    number: "4",
    icon: "🎯",
    title: "Why We Collect and Use Information",
    content:
      "We use information to provide services, generate reports, improve the platform, and communicate with users.",
  },
  {
    number: "5",
    icon: "⚖️",
    title: "Our Basis for Processing",
    content:
      "Information is processed based on consent, contractual obligations, legal compliance, and legitimate business interests.",
  },
  {
    number: "6",
    icon: "🚫",
    title: "What Happens If You Do Not Share Information",
    content:
      "Certain services may not function properly if requested information is not provided.",
  },
  {
    number: "7",
    icon: "🔄",
    title: "Sharing of Information",
    content:
      "We do not sell personal data. Limited sharing may occur with authorised service providers or legal authorities.",
  },
  {
    number: "8",
    icon: "📊",
    title: "Business Data, Reports, and Client Ownership",
    content:
      "Clients retain ownership of raw business data shared with Munafa Engine.",
  },
  {
    number: "9",
    icon: "🗄️",
    title: "Data Retention",
    content:
      "Information may be retained for operational, legal, and compliance purposes.",
  },
  {
    number: "10",
    icon: "🔐",
    title: "Security Practices",
    content:
      "We implement reasonable security measures to protect user and business information.",
  },
  {
    number: "11",
    icon: "🍪",
    title: "Cookies, Analytics, and Similar Technologies",
    content:
      "We may use cookies, analytics, and tracking tools to improve user experience.",
  },
  {
    number: "12",
    icon: "📱",
    title: "Mobile App Permissions",
    content:
      "Mobile applications may request permissions necessary for proper functionality.",
  },
  {
    number: "13",
    icon: "✅",
    title: "Your Rights and Choices",
    content:
      "Users may request access, correction, or deletion of information where legally permitted.",
  },
  {
    number: "14",
    icon: "📞",
    title: "Grievance and Privacy Contact",
    content:
      "Privacy-related concerns may be addressed through official Munafa Engine contact channels.",
  },
  {
    number: "15",
    icon: "🌐",
    title: "Third-Party Links and Platforms",
    content:
      "External websites or third-party services may have separate privacy practices.",
  },
  {
    number: "16",
    icon: "👶",
    title: "Children's Data",
    content:
      "Munafa Engine services are not intended for children under applicable legal age.",
  },
  {
    number: "17",
    icon: "🌍",
    title: "International or External Processing",
    content:
      "Data may be processed using secure external infrastructure or third-party systems.",
  },
  {
    number: "18",
    icon: "🔄",
    title: "Changes to This Privacy Policy",
    content:
      "This Privacy Policy may be updated periodically.",
  },
  {
    number: "19",
    icon: "📝",
    title: "Contact and Final Note",
    content:
      "By using Munafa Engine, you acknowledge this Privacy Policy.",
  },
];

export default function PrivacyPolicyModal({
  isOpen,
  onClose,
  onOpenTerms,
  onOpenRefund
}) {
  const scrollToClause = (id) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.privacyModal}>
        <div className={styles.mainContent}>

          {/* LEFT */}
          <div className={styles.leftSection}>

            <div className={styles.badge}>
              LEGAL PAGE
            </div>

            <h1 className={styles.heroTitle}>
              Privacy Policy
            </h1>

            <p className={styles.description}>
              This Privacy Policy explains how Munafa
              Engine collects, uses, stores, shares,
              protects, and otherwise handles
              personal data and business-related
              information.
            </p>

            <p className={styles.description}>
              By using our Platform or Services, you
              acknowledge this Privacy Policy.
            </p>

            <div className={styles.quickCard}>

              <div className={styles.quickHeader}>
                <h3>Quick Navigation</h3>

                <span>19 Clauses</span>
              </div>

              <div className={styles.quickGrid}>
                {privacyCards.map((item, index) => (
                  <button
                    key={index}
                    className={styles.quickItem}
                    onClick={() =>
                      scrollToClause(
                        `privacy-${item.number}`
                      )
                    }
                  >
                    <span>
                      {item.number.padStart(
                        2,
                        "0"
                      )}
                    </span>

                    <p>{item.title}</p>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className={styles.rightSection}>

            <div className={styles.imageWrapper}>
              <img
                src={privacyImage}
                alt="Privacy Policy"
                className={styles.heroImage}
               loading="lazy" decoding="async"/>
            </div>

            <div className={styles.cards}>
              {privacyCards.map((item, index) => (
                <div
                  key={index}
                  id={`privacy-${item.number}`}
                  className={styles.termCard}
                >
                  <div className={styles.cardIcon}>
                    {item.icon}
                  </div>

                  <div className={styles.cardContent}>
                    <h4>
                      {item.number}. {item.title}
                    </h4>

                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.bottomBar}>
              🔒 Your data is private, secure,
              and handled with care.
            </div>
          </div>
        </div>

        <div className={styles.footer}>

          <div className={styles.footerLogo}>
            MUNAFA ENGINE
          </div>

          <div className={styles.footerLinks}>
            <button
              onClick={onOpenTerms}
              className={styles.navLink}
            >
              Terms & Conditions
            </button>

            <button
              onClick={onOpenRefund}
              className={styles.navLink}
            >
              Refund & Cancellation Policy
            </button>
          </div>

          <div className={styles.footerCopy}>
            © 2026 Munafa Engine. All rights
            reserved.
          </div>
        </div>
      </div>
    </Modal>
  );
}